import { render, staticRenderFns } from "./table_social.vue?vue&type=template&id=6adb5b96&scoped=true"
import script from "./table_social.vue?vue&type=script&lang=js"
export * from "./table_social.vue?vue&type=script&lang=js"
import style0 from "./table_social.vue?vue&type=style&index=0&id=6adb5b96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb5b96",
  null
  
)

export default component.exports